import {
  Box,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import GreyTrophyIco from "../../../../assets/icons/GreyTrophyIco";
import ScoreCupIco from "../../../../assets/icons/ScoreCupIco";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  StyledTableBodyTableCell,
  StyledTableTitleTableCell,
  TableContainerBorder,
} from "../../../common-components/StyledComponents";
import { CommonTippy } from "../../style";

const getRatingColor = (rating) => {
  console.log(rating, "rating");
  if (rating > 4) return "#28A745";
  if (rating > 2) return "#F79009";
  return "#DC3545";
};

function Skills({ SummaryJobData, tableLoader, attributeHeaderData }) {
  return (
    <TableContainerBorder marginTop="0px">
      <Table>
        <TableHead style={{ backgroundColor: "#F9FAFB" }}>
          <TableRow>
            {attributeHeaderData.map((item, index) => (
              <StyledTableTitleTableCell key={index} minWidth={item.width}>
                <CommonGrid2
                  display={"flex"}
                  justifyContent={"start"}
                  alignItems={"center"}
                  gap={"10px"}
                  width={"max-content"}
                >
                  {item.title}
                  {item?.count > 0 && (
                    <CommonGrid2
                      display={"flex"}
                      gap={"5px"}
                      border={"1px solid #DCDFE4"}
                      padding={"0px 5px"}
                      borderRadius={"5px"}
                      alignItems={"center"}
                      background="#ffff"
                      fontSize={"14px"}
                      fontWeight={700}
                      width={"max-content"}
                    >
                      <CustomDiv>
                        <ScoreCupIco />
                      </CustomDiv>
                      {item?.count}
                    </CommonGrid2>
                  )}
                </CommonGrid2>
              </StyledTableTitleTableCell>
            ))}
          </TableRow>
        </TableHead>
        {tableLoader ? (
          <>
            {Array.from({ length: 3 }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {Array.from({ length: attributeHeaderData.length }).map(
                  (_, colIndex) => (
                    <TableCell key={colIndex}>
                      <HandleSkeletion height={30} />
                    </TableCell>
                  )
                )}
              </TableRow>
            ))}
          </>
        ) : (
          <TableBody>
            {SummaryJobData &&
              SummaryJobData.skill.map((row) => (
                <TableRow key={row.id}>
                  <StyledTableBodyTableCell>
                    {row.skill}
                  </StyledTableBodyTableCell>
                  {row.candidates.map((item) => (
                    <StyledTableBodyTableCell>
                      <CommonTippy
                        content={item.justification}
                        placement="top"
                        color={"#7F56D9"}
                        fontSize="12px"
                      >
                        <Box display="flex" alignItems="center">
                          <Rating
                            value={item.start_value}
                            precision={0.5}
                            readOnly
                            sx={{
                              color: getRatingColor(item.start_value),
                              fontSize: "20px",
                              mr: 1,
                            }}
                          />
                          <Box
                            display={"flex"}
                            gap={"5px"}
                            alignItems={"center"}
                          >
                            <Typography
                              fontWeight={500}
                              fontSize={"15px"}
                              color={"#101828"}
                            >
                              {item.start_value}
                            </Typography>
                            {item.is_best_candidate && <GreyTrophyIco />}
                          </Box>
                        </Box>
                      </CommonTippy>
                    </StyledTableBodyTableCell>
                  ))}

                  <StyledTableBodyTableCell>
                    {row.best_candidate?.name}
                  </StyledTableBodyTableCell>

                  <StyledTableBodyTableCell>
                    {row.best_candidate?.star_value}
                  </StyledTableBodyTableCell>
                </TableRow>
              ))}
          </TableBody>
        )}
      </Table>
    </TableContainerBorder>
  );
}

export default Skills;
